import gql from "graphql-tag";
const INTEGRATION_SYSTEMS = gql`
	query integrationSystems(
		$skip: Int
		$take: Int
		$where: IntegrationSystemFilterInput
		$order: [IntegrationSystemSortInput!]
	) {
		integrationSystems(
			skip: $skip
			take: $take
			where: $where
			order: $order
		) {
			items {
				id
				name
				settings
				settingsScheme
			}
		}
	}
`;
const INTEGRATION_SYSTEMS_LOOKUP = gql`
	query integrationSystems(
		$skip: Int
		$take: Int
		$where: IntegrationSystemFilterInput
		$order: [IntegrationSystemSortInput!]
	) {
		integrationSystems(
			skip: $skip
			take: $take
			where: $where
			order: $order
		) {
			items {
				id
				name
			}
		}
	}
`;
const INTEGRATION_SYSTEMS_LOGS = gql`
	query integrationSystemLogs(
		$skip: Int
		$take: Int
		$where: IntegrationSystemLogFilterInput
		$order: [IntegrationSystemLogSortInput!]
	) {
		integrationSystemLogs(
			skip: $skip
			take: $take
			where: $where
			order: $order
		) {
			totalCount
			pageInfo {
				hasNextPage
			}
			items {
				status
				request
				response
				method
				direction
				responseStatusCode
				error
				createdOn
				duration
				integrationSystemId
				integrationSystem {
					name
				}
			}
		}
	}
`;
const CHANGE_INTEGRATION_SYSTEM_SETTINGS = gql`
	mutation changeIntegrationSystemSettings(
		$input: IntegrationSystemSettingsInput!
	) {
		changeIntegrationSystemSettings(input: $input) {
			settings
			settingsScheme
			name
			description
			id
			createdOn
			createdById
			modifiedOn
			modifiedById
			isDeleted
		}
	}
`;
export {
  CHANGE_INTEGRATION_SYSTEM_SETTINGS,
  INTEGRATION_SYSTEMS,
  INTEGRATION_SYSTEMS_LOGS,
  INTEGRATION_SYSTEMS_LOOKUP
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
